import { Nomenclature } from "entities/orders/model"
import { NomenclatureItemStyled } from "./style";

interface NomenclatureItemProps {
    nomenclature: Nomenclature;
}

export const NomenclatureItem = ({
    nomenclature
}:NomenclatureItemProps) => {
    return (
        <NomenclatureItemStyled>
            <span>{nomenclature.name} (₽ {nomenclature.price})</span>
        </NomenclatureItemStyled>
    )
}